export const TOOL_LABELS: Record<string, string> = {
  keyword_bm25: "BM25 keyword search",
  vector_search: "Vector search",
  multi_vector_search: "Page-level vector search",
  hybrid_fuse: "Hybrid fusion",
  graph_neighborhood: "Knowledge graph",
  community_summary: "Community summary",
  path_search: "Path search",
  cite_align: "Citation alignment",
  // ADR-104 v3 deep-research worker tools (worker-side names, not T1–T8).
  search: "Search",
  explore_graph: "Explore graph",
  read_source: "Read source",
};

export function labelFor(tool: string): string {
  return TOOL_LABELS[tool] ?? tool;
}
